import parseDomain from 'parse-domain'

const whiteDomainList = [
  'mgtv'
]

const isValidUrl = url => {
  return whiteDomainList.some(domain => {
    const result = parseDomain(url)
    if (result) {
      return result.domain === domain
    }
    return false
  })
}

export const cleanUrl = url => {
  if (isValidUrl(url)) {
    return url
  }
  return 'https://www.mgtv.com'
}
